<template>
  <div id="magazine">
    <TopList
      @setType="setType"
      :navList="['基本信息', '期刊简介', '征稿启事']"
    ></TopList>
    <MaDetails
      :periodicalDatabase="periodicalDatabase"
      :maInfo="maInfo"
      @getDetails="getDetails"
      v-if="type === 0"
    ></MaDetails>
    <Synopsis
      @getDetails="getDetails"
      :maInfo="maInfo"
      v-if="type === 1"
    ></Synopsis>
    <Enlightenment
      @getDetails="getDetails"
      :maInfo="maInfo"
      v-if="type === 2"
    ></Enlightenment>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import MaDetails from "./components/maDetails";
import Synopsis from "./components/synopsis";
import Enlightenment from "./components/enlightenment";
export default {
  name: "index",
  components: {
    TopList,
    MaDetails,
    Synopsis,
    Enlightenment,
  },
  created() {
    this.getDetails();
  },
  data() {
    return {
      type: 0,
      maInfo: {},
      periodicalDatabase: [],
    };
  },
  methods: {
    async getDetails() {
      let results = await this.$apis.userServe.getMaDetails();
      this.maInfo = results.content.periodicalInfo.periodical;
      this.periodicalDatabase = results.content.periodicalInfo.periodicalDatabase ? results.content.periodicalInfo.periodicalDatabase : []
    },
    setType(num) {
      this.type = num;
      this.getDetails();
    },
  },
};
</script>

<style lang="scss" scoped>
#magazine {
  width: 1200px;
}
</style>
